import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SiScrubBarComponent } from '@splixer/player';
import { NgStyle } from '@angular/common';

@Component({
  selector: 'kexp-media-scrub-bar',
  templateUrl: 'media-scrub-bar.component.html',
  styleUrl: 'media-scrub-bar.component.scss',
  imports: [
    NgStyle
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KexpMediaScrubBarComponent extends SiScrubBarComponent {

}
